import { Component } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MsalBroadcastService } from "@azure/msal-angular";
import { AuthService } from "@shared/auth/auth.service";
import { EventMessage, EventType } from "@azure/msal-browser";
import { filter } from "rxjs";
import { environment } from "@env/environment";
import { SettingsService } from "app/services/core/settings.service";
import { SharedService } from "@shared/services/shared.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {

  loggingIn: boolean = false;
  defaultRoute: string = 'lab-user-menu';
  redirectFromProfile: string = 'redirectFromProfile';
  route: string = 'route';
  authType: string = environment.auth.defaultAuth;


  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl("", Validators.required),
    password: new UntypedFormControl("", Validators.required),
  });

  constructor(
    private sharedService: SharedService,
    public settings: SettingsService,
    private router: Router,
    private authService: AuthService,
    private msalBroadcastService: MsalBroadcastService
  ) { }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.loggingIn = true;
      this.authService.loadUserInformation();
      this.sharedService.getUserTheme();
      this.router.navigateByUrl(this.defaultRoute);
    }
    else {
      this.msalBroadcastService.msalSubject$
        .pipe(
          filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
        )
        .subscribe(() => {
          this.loggingIn = true;
          this.authService.loadUserInformation();
          // console.log('loadUserInformation');
          // delay(100000);
          // setTimeout(() => {
          // console.log('getUserTheme');
          // }, 100000);

          // Removed. Created a race condition when registering new user
          // this.sharedService.getUserTheme();
          this.router.navigateByUrl(this.defaultRoute);
        });
    }
  }
    
  login(): void{
    window.localStorage.setItem(this.redirectFromProfile, 'true');
    this.authService.login();
  }

  loginFailed(): boolean {
    return this.sharedService.loginFailed;
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  isB2C() : boolean {
    return this.authService.isB2C();
  }

  isAAD() : boolean {
    return this.authService.isAAD();
  }

  loginRedirect(redirect: string): void {
    if (redirect == 'cancel' || redirect == null || redirect == '') {
      return;
    }
    window.localStorage.setItem(this.route, redirect);
    // this.authService.login();
  }
  
}

